function showRecoverPasswordForm() {
    document.querySelector(".customer-form-page").classList.add("recover");
    location.hash = "#recover";
    window.scrollTo(0, 0);
}
function hideRecoverPasswordForm() {
    document.querySelector(".customer-form-page").classList.remove("recover");
    location.hash = "";
    window.scrollTo(0, 0);
}

document.querySelectorAll('.customer-form-page form').forEach((form) => {
    form.addEventListener('submit', (e) => {
        var error = false;
        form.querySelectorAll('.error').forEach((element) => {
            element.classList.remove('error');
        });
        form.querySelectorAll('.required').forEach((element) => {
            if (!element.value.trim()) {
                error = true;
                element.classList.add('error');
                form.querySelector('.error-msg').innerHTML = 'Please complete all the required fields.';
            }
        });
        if (!error && form.querySelector('.email')) {
            if (!$s.validateEmail(form.querySelector('.email').value)) {
                error = true;
                form.querySelector('.email').classList.add('error');
                form.querySelector('.error-msg').innerHTML = 'Please enter a valid email address.';
            }
        }
        if (!error && form.querySelector('[name="customer[password_confirmation]"]')) {
            if (form.querySelector('[name="customer[password]"]').value !== form.querySelector('[name="customer[password_confirmation]"]').value) {
                error = true;
                form.querySelector('[name="customer[password_confirmation]"]').classList.add('error');
                form.querySelector('.error-msg').innerHTML = 'The password must match with its confirmation.';
            }
        }
        if (error) {
            e.preventDefault();
            e.stopImmediatePropagation();
            form.querySelector('.error-msg').style.display = 'block';
            return false;
        }
    });
});

if (window.location.hash.includes("#recover")) {
    showRecoverPasswordForm()
}